const SET_BOOKS = (state, books) => {
  state.books = books
}

const SET_BOOK = (state, book) => {
  state.book = book
}

const SET_SAVED_BOOKS = (state, books) => {
  state.savedBooks = books
}

const SET_BOOK_TOC = (state, toc) => {
  state.toc = toc.chapters
}

export default {
  SET_BOOKS,
  SET_BOOK,
  SET_SAVED_BOOKS,
  SET_BOOK_TOC
}
